module.exports = __webpack_public_path__ + "static/media/thumbnail.0c982ccb.jpg";